(function () {
  const TYPE_WRAP = '.variant-input-wrap[data-index="option1"]';
  const SIZE_WRAP = '.variant-input-wrap[data-index="option2"]';
  const TYPE_RADIOS = `${TYPE_WRAP} input[type="radio"]`;
  const TYPE_SELECT = `${TYPE_WRAP} select`;
  const SIZE_RADIOS = `${SIZE_WRAP} input[type="radio"]`;
  const SIZE_SELECT = `${SIZE_WRAP} select`;

  // --- helpers ---
  const getTypeVal = () => {
    const r = document.querySelector(`${TYPE_WRAP} input[type="radio"]:checked`);
    if (r) return (r.value || '').trim();
    const s = document.querySelector(TYPE_SELECT);
    return s ? (s.value || '').trim() : '';
  };

  // Build allowed sizes for a type by reading the hidden no-JS select
  function getAllowedSizesFor(typeVal) {
    const sel = document.querySelector('select.product-single__variants.no-js');
    if (!sel || !typeVal) return null;

    const allowed = new Set();
    sel.querySelectorAll('option').forEach(o => {
      const left = (o.textContent || '').split(' - ')[0].trim(); // e.g. "Dame / S"
      const parts = left.split('/');
      if (parts.length >= 2) {
        const type = parts[0].trim();
        const size = parts.slice(1).join('/').trim();
        if (type.toLowerCase() === typeVal.toLowerCase()) {
          allowed.add(size);
        }
      }
    });
    return allowed;
  }

  // --- filter radios ---
  function filterSizeRadios() {
    const typeVal = getTypeVal();
    const radios = Array.from(document.querySelectorAll(SIZE_RADIOS));
    if (!radios.length) return false;

    const allowed = getAllowedSizesFor(typeVal);
    let checkedVisible = false;

    radios.forEach(r => {
      const holder = r.closest('label,.variant-input') || r.parentElement;
      const label = (r.getAttribute('data-option-value') || r.value || '').trim();
      const show = allowed ? allowed.has(label) : true;

      if (holder) holder.style.display = show ? '' : 'none';
      r.dataset._vf_visible = show ? '1' : '0';
      if (!show && r.checked) r.checked = false;
      if (show && r.checked && !r.disabled) checkedVisible = true;
    });

    if (!checkedVisible) {
      const first = radios.find(r => r.dataset._vf_visible === '1' && !r.disabled);
      if (first) {
        first.checked = true;
        first.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      const cur = radios.find(r => r.dataset._vf_visible === '1' && r.checked);
      if (cur) cur.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  // --- filter select ---
  function filterSizeSelect() {
    const sel = document.querySelector(SIZE_SELECT);
    if (!sel) return false;

    const typeVal = getTypeVal();
    const allowed = getAllowedSizesFor(typeVal);
    const all = Array.from(sel.options);

    const keep = allowed
      ? all.filter(o => !o.value || allowed.has((o.textContent || o.value).trim()))
      : all;

    const prev = sel.value;
    sel.innerHTML = '';
    keep.forEach(o => {
      const opt = new Option(o.text, o.value, false, false);
      opt.disabled = o.disabled;
      sel.appendChild(opt);
    });

    const canKeep = keep.some(o => o.value === prev && !o.disabled);
    if (canKeep) {
      sel.value = prev;
    } else {
      const first = Array.from(sel.options).find(o => o.value && !o.disabled) || sel.options[0];
      if (first) sel.value = first.value;
    }
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function apply() {
    if (!filterSizeRadios()) filterSizeSelect();
  }

  // ---- scheduler ----
  let scheduled = false;
  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  };

  // ---- init ----
  let bound = false;
  let mo = null;

  function init() {
    if (bound) return;
    bound = true;

    scheduleApply();
    setTimeout(scheduleApply, 60);
    setTimeout(scheduleApply, 180);

    // Type change
    document.addEventListener('change', e => {
      if (e.target.matches(TYPE_RADIOS) || e.target.matches(TYPE_SELECT)) {
        scheduleApply();
      }
    });

    // Click fallback
    document.addEventListener('click', e => {
      if (e.target.closest(TYPE_WRAP) && (e.target.closest('label,[role="radio"],button,input[type="radio"]'))) {
        scheduleApply();
      }
    });

    // Watch size wrap
    const node = document.querySelector(SIZE_WRAP);
    if (node && !mo) {
      mo = new MutationObserver(() => scheduleApply());
      mo.observe(node, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  ['shopify:section:load','shopify:section:select','shopify:block:select'].forEach(e =>
    document.addEventListener(e, init)
  );
})();
